/*
 * Plugin that provides features to select groups
 */

(function(window, document, undefined) {

	let $, ScopeSelector, Ladda;
	const idSelector = '#';
	const settings = {};

	var options = {
		'organizationFilterId' : 'organizationFilter',
        'availableOrganizationsInputId' : 'availableOrganizations',
        'selectedOrganizationsInputId' : 'selectedOrganizations',
        'organizationsSelectButtonSelector' : 'div.move-objects > a.btn-right',
        'organizationsDeselectButtonSelector' : 'div.move-objects > a.btn-left',
        'organizationGroupIdsInput' : 'organizationGroupIds'
	};
	
	$ = window.jQuery;
	Ladda = window.Ladda;
	
	ScopeSelector = function(settings) {

		if (!(this instanceof ScopeSelector))
			return new ScopeSelector(settings);

		if (settings) {
			$.extend(options, settings);
		}
		
		this.init();
		
		bindScopeGroupSelectionEvents();
	};

	ScopeSelector.prototype.init = function() {
		let portletNameSpace = options.portletNameSpace;
		if ( portletNameSpace !== '' || portletNameSpace !== undefined  )
		{
			portletNameSpace = '';
		}
		
		options.formId = idSelector + portletNameSpace + options.formId;
		options.organizationFilterId = idSelector + portletNameSpace + 'organizationFilter';
		options.availableOrganizationsInputId = idSelector + portletNameSpace + 'availableOrganizations';
		options.selectedOrganizationsInputId = idSelector + portletNameSpace + 'selectedOrganizations';
		options.organizationGroupIdsInput = idSelector + portletNameSpace + 'organizationGroupIds';
		
	};
	
	function bindScopeGroupSelectionEvents() {
	  	
	  	//Bind organization selectors
	  	//select
	  	$(options.organizationsSelectButtonSelector).click(function() {
			const source = $(options.availableOrganizationsInputId);
			const selected = source.find('option:selected');
			const target = $(options.selectedOrganizationsInputId);

			$(selected).each(function (index, value) {
                target.append($(value).clone());
                $(value).remove();
            });
            
            //Enforce visibility of all selected options
            $(target).find('option').each(function (index, value) {
                $(value).show();
            });
            
            repopulateOptionsInput(options.selectedOrganizationsInputId, options.organizationGroupIdsInput);
        });
	  	
	  	//deselect
	  	$(options.organizationsDeselectButtonSelector).click(function() {
			const source = $(options.selectedOrganizationsInputId);
			const selected = source.find('option:selected');
			const target = $(options.availableOrganizationsInputId);

			$(selected).each(function (index, value) {
                target.append($(value).clone());
                $(value).remove();
            });
            
            repopulateOptionsInput(options.selectedOrganizationsInputId, options.organizationGroupIdsInput);
        });
	  	
		//Bind filter
		$(options.organizationFilterId).keyup(function() {

			const filter = $(options.organizationFilterId);
			const filterableSelect = $(options.availableOrganizationsInputId);
			const filterableOptions = $(filterableSelect).children();

			//Filter when input not empty
			if ( filter.val().length > 0 ) {
			
				$(filterableOptions).each( function( index, value ) {
					console.log( index + ": " + value );
					const filterVal = filter.val().toLowerCase();

					// If the list item contains the filter text then leave it there/show it
					if( $(value).text().toLowerCase().indexOf(filterVal) !== -1 ) {
						$(value).show();
					}
					else if ( $(value).text().toLowerCase().indexOf(filterVal) === -1 ) {
						$(value).hide();
					}
					
				});
			}
			else //or display everything
			{
				$(filterableOptions).show();
			}
		
		});
		
		//Fill in selected options when loading page
		repopulateOptionsInput(options.selectedOrganizationsInputId, options.organizationGroupIdsInput);
	};
	
	function repopulateOptionsInput(sourceId, targetId)
    {
		const out = [];
		const selectedElements = $(sourceId).find('option');
		$(selectedElements).each(function( index, value ) {
            out.push( $(value).val() );
        });
  
        if ( out.length > 0 )
        {
            $(targetId).val(out.join(','));
        }
        else
        {
            $(targetId).val('');
        }
    }
	
	window.ScopeSelector = ScopeSelector;
	
})(window, window.document);